/**
 * Escala de turnos do usuário, no detalhe do usuário — Nexora Grid (frontend, US-1607).
 *
 * Criado em: 19/10/2026 · Última modificação: 19/10/2026 · Versão: 1.0.0
 *
 * Dias e hora de início de cada turno. No início do turno, quem tem o Telegram/WhatsApp vinculado recebe o resumo da
 * troca de turno (alarmes abertos, incidentes, manobras e pendências das últimas 12 h).
 */
import { useEffect, useState } from "react";
import { api, ErroApi } from "../api";
import { DIAS } from "./tipos";

type Turno = { dias: number[]; inicio: string };
type Escala = { turnos: Turno[]; fuso: string };

export function EscalaTurnos({ usuarioId, edita }: { usuarioId: string; edita: boolean }) {
  const [escala, setEscala] = useState<Escala | null>(null);
  const [aviso, setAviso] = useState<string | null>(null);
  const url = `/v1/usuarios/${usuarioId}/escala`;
  useEffect(() => { api<Escala>(url).then(setEscala).catch(() => setEscala(null)); }, [url]);
  if (!escala) return null;
  const mudar = (i: number, t: Partial<Turno>) => setEscala({ ...escala, turnos: escala.turnos.map((x, j) => (j === i ? { ...x, ...t } : x)) });
  const salvar = async () => {
    try { setEscala(await api<Escala>(url, { metodo: "PUT", corpo: escala })); setAviso("Escala salva: o resumo chega no início de cada turno pelo canal vinculado."); }
    catch (x) { setAviso(x instanceof ErroApi ? `Não foi possível: ${x.message}` : "Falha de rede."); }
  };
  return (
    <section className="filiais" aria-label="Escala de turnos">
      <h3>Escala de turnos</h3>
      <p className="nx-suave">No início de cada turno, a pessoa recebe pelo Telegram/WhatsApp o resumo da troca de turno (alarmes abertos, incidentes, manobras e pendências das últimas 12 h).</p>
      {aviso && <p className="nx-suave" role="status">{aviso}</p>}
      {!escala.turnos.length && <p className="nx-suave">sem escala</p>}
      {escala.turnos.map((t, i) => (
        <div key={i} className="linha-condicao">
          {DIAS.map((d, n) => (
            <label key={d} className="nx-suave"><input type="checkbox" disabled={!edita} checked={t.dias.includes(n)}
              onChange={(e) => mudar(i, { dias: e.target.checked ? [...t.dias, n].sort() : t.dias.filter((x) => x !== n) })} /> {d}</label>
          ))}
          <div className="nx-campo"><label htmlFor={`turno-${i}`}>Início do turno {i + 1}</label>
            <input id={`turno-${i}`} type="time" disabled={!edita} value={t.inicio.slice(0, 5)} onChange={(e) => mudar(i, { inicio: `${e.target.value}:00` })} /></div>
          {edita && <button type="button" className="nx-botao" onClick={() => setEscala({ ...escala, turnos: escala.turnos.filter((_, j) => j !== i) })}>Remover</button>}
        </div>
      ))}
      {edita && <div className="acoes-conta">
        {escala.turnos.length < 6 && <button type="button" className="nx-botao" onClick={() => setEscala({ ...escala, turnos: [...escala.turnos, { dias: [0, 1, 2, 3, 4], inicio: "07:00:00" }] })}>+ turno</button>}
        <button type="button" className="nx-botao" disabled={escala.turnos.some((t) => !t.dias.length)} onClick={() => void salvar()}>Salvar escala</button>
      </div>}
    </section>
  );
}
